<div class="plantillas-panel" [ngClass]="panelClasses">

  <!-- HEADER -->
  <div class="panel-header">
    <div class="panel-title">
      <mat-icon>description</mat-icon>
      <span>PLANTILLAS</span>
    </div>

    <div class="panel-actions">
      <button
        mat-icon-button
        class="action-btn"
        (click)="onNewPlantilla()"
        matTooltip="Nueva Plantilla"
        matTooltipPosition="below"
        [disabled]="isLoading">
        <mat-icon>add</mat-icon>
      </button>

      <button
        mat-icon-button
        class="action-btn"
        (click)="onRefresh()"
        matTooltip="Actualizar"
        matTooltipPosition="below"
        [disabled]="isLoading">
        <mat-icon>refresh</mat-icon>
      </button>

      <button
        mat-icon-button
        class="action-btn"
        (click)="onToggleFilters()"
        matTooltip="Filtros"
        matTooltipPosition="below"
        [disabled]="isLoading">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </div>

  <!-- SEARCH -->
  <div class="search-container">
    <div class="search-row">
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          placeholder="Buscar..."
          [formControl]="searchControl"
          maxlength="100"
          autocomplete="off">

        <button
          mat-icon-button
          matSuffix
          *ngIf="searchControl.value && !hasSearchErrors"
          (click)="clearSearch()"
          matTooltip="Limpiar">
          <mat-icon>clear</mat-icon>
        </button>

        <mat-icon
          matSuffix
          *ngIf="hasSearchErrors"
          color="warn"
          matTooltip="{{searchErrorMessage}}">
          error
        </mat-icon>

        <mat-error *ngIf="hasSearchErrors">
          {{ searchErrorMessage }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- LOADING -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Cargando...</span>
  </div>

  <!-- PLANTILLAS LIST -->
  <div class="plantillas-container" *ngIf="!isLoading">

    <div
      *ngFor="let plantilla of filteredPlantillas; trackBy: trackByPlantillaId"
      class="plantilla-item"
      [class.selected]="selectedPlantilla?.id === plantilla.id"
      (click)="onPlantillaClick(plantilla)"
      (dblclick)="onPlantillaDoubleClick(plantilla)"
      [attr.aria-label]="'Plantilla: ' + (plantilla.titulo || 'Sin título')"
      role="button"
      tabindex="0"
      (keydown.enter)="onPlantillaDoubleClick(plantilla)"
      (keydown.space)="onPlantillaClick(plantilla)">

      <div class="plantilla-header">
        <mat-icon class="plantilla-icon">description</mat-icon>

        <div class="plantilla-info">
          <div class="plantilla-title" [title]="plantilla.titulo || 'Sin título'">
            {{ plantilla.titulo || 'Sin título' }}
          </div>
          <!-- <div class="plantilla-type">
            {{ getPlantillaTipo(plantilla) }}
          </div> -->
        </div>

        <button
          mat-icon-button
          class="plantilla-menu"
          [matMenuTriggerFor]="plantillaMenu"
          (click)="$event.stopPropagation()"
          [matMenuTriggerData]="{ plantilla: plantilla }"
          matTooltip="Opciones">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #plantillaMenu="matMenu">
          <ng-template matMenuContent let-plantilla="plantilla">
            <button
              mat-menu-item
              (click)="onPlantillaDoubleClick(plantilla)"
              [disabled]="!plantilla?.id">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>

            <button
              mat-menu-item
              (click)="onUseAsEscrito(plantilla)"
              [disabled]="!plantilla?.id">
              <mat-icon>file_copy</mat-icon>
              <span>Usar como Escrito</span>
            </button>

            <button
              mat-menu-item
              (click)="onDuplicatePlantilla(plantilla)"
              [disabled]="!plantilla?.id">
              <mat-icon>content_copy</mat-icon>
              <span>Duplicar</span>
            </button>

            <mat-divider></mat-divider>

            <button
              mat-menu-item
              (click)="onDeletePlantilla(plantilla)"
              class="delete-action"
              [disabled]="!plantilla?.id">
              <mat-icon>delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </ng-template>
        </mat-menu>
      </div>

      <div class="plantilla-description" *ngIf="plantilla.descripcion" [title]="plantilla.descripcion">
        {{ plantilla.descripcion }}
      </div>
    </div>

    <!-- EMPTY STATE -->
    <div *ngIf="filteredPlantillas.length === 0 && !hasSearchErrors" class="empty-state">
      <mat-icon class="empty-icon">description</mat-icon>
      <p *ngIf="!searchControl.value">No hay plantillas disponibles</p>
      <p *ngIf="searchControl.value">Sin resultados para "{{ searchControl.value }}"</p>

      <button
        mat-stroked-button
        (click)="onNewPlantilla()"
        *ngIf="!searchControl.value"
        class="with-icon">
        <mat-icon>add</mat-icon>
        Nueva Plantilla
      </button>

      <button
        mat-stroked-button
        (click)="clearSearch()"
        *ngIf="searchControl.value"
        class="with-icon">
        <mat-icon>clear</mat-icon>
        Limpiar
      </button>
    </div>

    <!-- ERROR STATE -->
    <div *ngIf="hasSearchErrors" class="empty-state">
      <mat-icon class="empty-icon" color="warn">error</mat-icon>
      <p>Búsqueda inválida</p>
      <p style="font-size: 11px; color: var(--error-color);">{{ searchErrorMessage }}</p>
      <button
        mat-stroked-button
        (click)="clearSearch()"
        class="with-icon">
        <mat-icon>clear</mat-icon>
        Limpiar
      </button>
    </div>
  </div>

  <!-- HELP TEXT -->
  <div class="help-text">
    <mat-icon>info</mat-icon>
    <span>Doble-click para editar</span>
  </div>
</div>
